"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _StateList = _interopRequireDefault(require("../../components/finpro/StateList"));
var _StateCityList = _interopRequireDefault(require("../../components/finpro/StateCityList"));
var _CityAgencyList = _interopRequireDefault(require("../../components/finpro/CityAgencyList"));
var _titleHeadTag = require("../../lib/titleHeadTag");
var _richTextField = require("../../lib/richTextField");
var _reactBootstrap = require("react-bootstrap");
var _FinproHeadTags = _interopRequireDefault(require("../../components/finpro/headtag/FinproHeadTags"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to display finpro state and city pages
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering.fields.statelist State list for listing page
 * @param {object} props.rendering.fields.state State detail with city list for state page
 * @param {object} props.rendering.fields.city City detail with agencies list for city page
 *
 * @returns {React.ReactElement} Agent profile
 */
function FinproStateDisplay(props) {
  if (!props.rendering.fields) {
    return null;
  }
  var ProcessHeadtags = () => {
    var metadata = {
      pagePath: props.params.pagePath,
      pageQuery: props.params.pageQuery,
      utagSiteName: props.pageprops.utagSiteName,
      addUtagLoginCookie: props.pageprops.addUtagLoginCookie
    };
    if (props.rendering.fields.city) {
      metadata.location = {
        city: props.rendering.fields.city.cityName,
        state: props.rendering.fields.city.state.stateCode,
        stateName: props.rendering.fields.city.state.stateName
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'city',
        metadata: metadata
      });
    } else if (props.rendering.fields.state) {
      metadata.location = {
        state: props.rendering.fields.state.stateCode,
        stateName: props.rendering.fields.state.stateName
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'state',
        metadata: metadata
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'country',
        metadata: metadata
      });
    }
  };
  var GetBreadcrumb = props => {
    if (props.stateLink) {
      return /*#__PURE__*/_react.default.createElement("nav", {
        "aria-label": "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement("ol", {
        className: "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "breadcrumb-item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: '/us'
      }, 'Select By State')), /*#__PURE__*/_react.default.createElement("li", {
        className: "breadcrumb-item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: props.stateLink
      }, props.stateName)), /*#__PURE__*/_react.default.createElement("li", {
        className: "breadcrumb-item active",
        "aria-current": props.cityName
      }, props.cityName)));
    } else {
      return /*#__PURE__*/_react.default.createElement("nav", {
        "aria-label": "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement("ol", {
        className: "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "breadcrumb-item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: '/us'
      }, 'Select By State')), /*#__PURE__*/_react.default.createElement("li", {
        className: "breadcrumb-item active",
        "aria-current": props.stateName
      }, props.stateName)));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement(ProcessHeadtags, null), props.rendering.fields.statelist && /*#__PURE__*/_react.default.createElement("div", {
    className: "finpro-state-list container"
  }, !(0, _lodash.isEmpty)(props.pageprops.displayTitle) && (0, _titleHeadTag.headTagTitle)(props.pageprops.displayTitle, undefined, 'h1'), !(0, _lodash.isEmpty)(props.pageprops.displayTagline) && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, (0, _richTextField.parseHTML)(props.pageprops.displayTagline)), /*#__PURE__*/_react.default.createElement(_StateList.default, {
    statelist: props.rendering.fields.statelist
  }), !(0, _lodash.isEmpty)(props.pageprops.disclaimer) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", null, (0, _richTextField.parseHTML)(props.pageprops.disclaimer)))), props.rendering.fields.state && /*#__PURE__*/_react.default.createElement("div", {
    className: "finpro-state container"
  }, props.pageprops.showBreadCrumb && /*#__PURE__*/_react.default.createElement(GetBreadcrumb, {
    stateName: props.rendering.fields.state.stateName
  }), !(0, _lodash.isEmpty)(props.pageprops.displayTitle) && (0, _titleHeadTag.headTagTitle)((0, _lodash.replace)(props.pageprops.displayTitle, '|replace|', props.rendering.fields.state.stateName), undefined, 'h1'), !(0, _lodash.isEmpty)(props.pageprops.displayTagline) && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, (0, _richTextField.parseHTML)(props.pageprops.displayTagline)), /*#__PURE__*/_react.default.createElement(_StateCityList.default, {
    cityList: props.rendering.fields.state.cities
  }), !(0, _lodash.isEmpty)(props.pageprops.disclaimer) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", null, (0, _richTextField.parseHTML)(props.pageprops.disclaimer)))), props.rendering.fields.city && /*#__PURE__*/_react.default.createElement("div", {
    className: "finpro-city"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "city-breadcrumb"
  }, props.pageprops.showBreadCrumb && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 8,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(GetBreadcrumb, {
    stateName: props.rendering.fields.city.state.stateName,
    stateLink: props.rendering.fields.city.state.stateUrl,
    cityName: props.rendering.fields.city.cityName
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-inline",
    href: "/"
  }, "Standard Search"))), !(0, _lodash.isEmpty)(props.pageprops.displayTitle) && (0, _titleHeadTag.headTagTitle)((0, _lodash.replace)(props.pageprops.displayTitle, '|replace|', props.rendering.fields.city.cityName), undefined, 'h1'), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-padding"
  }, props.rendering.fields.city.agencies.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("strong", null, props.rendering.fields.city.agencies.length), " ".concat(props.rendering.fields.city.agencies.length === 1 ? 'Agency' : 'Agencies', " in ").concat(props.rendering.fields.city.cityName, ", ").concat(props.rendering.fields.city.state.stateCode)))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "finpro-agency-list"
  }, /*#__PURE__*/_react.default.createElement(_CityAgencyList.default, {
    agencyList: props.rendering.fields.city.agencies,
    disclaimer: props.pageprops.disclaimer
  }))));
}
var _default = exports.default = FinproStateDisplay;